export function QAnalytics({ seo }) {
    return <></>;
}
